import logo from '../images/Logo_CDV_noclaim.svg';
import { Customization } from '@eduvision/toolkit';

export const Logo: Customization['Logo'] = {
	imageSrc: logo,
  maxWidth: '9rem' 
};
